import { Command } from "@ckeditor/ckeditor5-core";

export default class ApplyTemplateCommand extends Command {
  execute(template) {
    const editor = this.editor;
    editor.fire("cde:openApplyTemplate", template);
  }

  refresh() {
    this.isEnabled = true;
  }
}
